module.exports = __webpack_public_path__ + "img/65694.b8bc780b.png";